import React, { useState } from 'react';
import { Column, Columns } from 'components/Columns';
import Heading from '@hubins/components/Heading';
import __ from 'localisation';
import SimpleTable from 'modules/Tables/SimpleTable';
import LoadingBar from '@hubins/components/LoadingIndicators';
import { getMoney } from 'helpers';
import Comments from '@hubins/components/Comments';
import Button, { ButtonWrap } from '@hubins/components/Button';
import EditPortfolioModal from '@hubins/components/EditPortfolioModal';
import TaxDomiciles from '@hubins/components/TaxDomiciles';
import PortfolioProfileRolesTable from '@hubins/components/PortfolioProfileRolesTable';
import BackofficePortfolioLink from '@hubins/components/BackofficePortfolioLink/BackofficePortfolioLink';
import PortfolioHistory from '@hubins/components/PortfolioHistory/PortfolioHistory';
import BackofficeProfileAttributes from '@hubins/components/BackofficeProfileAttributes/BackofficeProfileAttributes';
import WithdrawalAccounts from '@hubins/components/WithdrawalAccounts/WithdrawalAccounts';

const typeValueHeaders = [
  {
    Header: '',
    accessor: 'type',
  },
  {
    Header: '',
    accessor: 'value',
  }
]

const Dashboard = ({ client, portfolio: propsPortfolio, backOfficeUser, userUuid }) => {

  const [openPortfolioModal, setOpenPortfolioModal] = useState(false);
  const [portfolio, setPortfolio] = useState(propsPortfolio);

  const portfolioData = [
    {
      type: __('insurance_number'),
      value: portfolio?.short_name ? <BackofficePortfolioLink profileUuid={portfolio?.policy_holder[0].uuid} portfolioUuid={portfolio?.uuid}>
        {portfolio?.short_name}
      </BackofficePortfolioLink> : <LoadingBar />,
    },
    {
      type: __('distributor'),
      value: portfolio?.distributor || <LoadingBar />,
    },
    {
      type: __('status'),
      value: portfolio?.status || <LoadingBar />,
    },
    {
      type: __('account_balance'),
      value: getMoney(portfolio?.account_balance || 0),
    },
    {
      type: __('market_value'),
      value: getMoney(portfolio?.market_value || 0),
    },
    {
      type: __('updated_at'),
      value: portfolio?.updated_at || <LoadingBar />,
    },
    {
      type: __('issued_at'),
      value: portfolio?.issue_date || '',
    },
    {
      type: __('terminated_at'),
      value: portfolio?.terminated_at || '',
    },
    {
      type: __('termination_type'),
      value: portfolio?.termination_type || '',
    },
  ];

  return (
    <Columns>
      <Column l="6">
        <Heading size="4" className='s-bottom-xl'>{__('policy_holder')}</Heading>
        <BackofficeProfileAttributes profile={client} canEdit={backOfficeUser} />
        <Heading size="5" className='s-bottom-m s-top-l'>{__('tax_domiciles')}</Heading>
        <TaxDomiciles profileUuid={client?.uuid} backofficeUser={backOfficeUser} />
      </Column>
      <Column l="6">
        <Heading size="4" className='s-bottom-xl'>{__('portfolio')}</Heading>
        <SimpleTable headers={typeValueHeaders} data={portfolioData} />
        {
          backOfficeUser && (
            <>
              <EditPortfolioModal
                portfolio={portfolio}
                open={openPortfolioModal}
                setOpen={setOpenPortfolioModal}
                setPortfolio={setPortfolio}
              />
              <ButtonWrap>
                <Button icon="pencil write 2" onClick={() => setOpenPortfolioModal(true)}>
                  {__('edit')}
                </Button>
                <PortfolioHistory portfolioUuid={portfolio?.uuid} />
              </ButtonWrap>
            </>
          )
        }
        <Heading size="5" className='s-bottom-m s-top-l'>{__('roles')}</Heading>
        <PortfolioProfileRolesTable profileUuid={client?.uuid} portfolioUuid={portfolio?.uuid} />
        <WithdrawalAccounts portfolioUuid={portfolio?.uuid} backOfficeUser={backOfficeUser} />
      </Column>
      <Column l="6">
        <Comments
          title={__('policy_holder_comments')}
          model='Profile'
          modelUuid={client?.uuid}
          userUuid={userUuid}
          presetChannels={['hubins_backoffice', 'hubins_compliance', 'quantum_backoffice', 'quantum_compliance']}
        />
      </Column>
      <Column l="6">
        <Comments
          title={__('portfolio_comments')}
          model='Portfolio'
          modelUuid={portfolio?.uuid}
          userUuid={userUuid}
          presetChannels={['hubins_backoffice', 'hubins_compliance', 'quantum_backoffice', 'quantum_compliance']}
        />
      </Column>
    </Columns>

  )
};

export default Dashboard;